// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"184":"c0f20c13","787":"3f71f449","996":"55bf1593"}[chunkId] + ".chunk.js";
};